import $ from 'jquery'
import 'select2/dist/js/select2.full.min'
import 'select2/dist/js/i18n/ru'
import { load } from '../../utils/ajax'
import toastr from '../../utils/toastr'
import { format } from '../../utils/currency'
import i18n from '../../utils/translate'
import settings from '../../utils/settings'

class Module {
  constructor ($module) {
    this.$module = $module
    this.$form = $module.find('form[name="yandex_subscription_campaign_start"]')
    this.$budgetType = $module.find('input[name="yandex_subscription_campaign_start[budgetType]"]')
    this.$duration = $module.find('input[name="yandex_subscription_campaign_start[duration]"]')
    // this.$promocode = $module.find(
    //   '#yandex_subscription_campaign_start_promocode')
    
    this.accountId = $module.data('account-id')
    this.campaignId = $module.data('campaign-id')
    
    this.priceMap = null
    
    this.$promocodeField = $module.find('.b-campaign__promocode-widget input')
    this.$promocodeBtnApply = $module.find('.b-campaign__promocode-widget .apply')
    this.$promocodeBtnDiscard = $module.find('.b-campaign__promocode-widget .discard')
    
    this.$alert = $module.find('.b-campaign__need-replenish')
    
    this.$startCampaignButton = $module.find('.js-start-campaign-button')
    
    this.init()
  }
  
  getPrice () {
    
    let self = this
    
    load(
      `/api/app/v1/networks/yandex-subscription/${this.accountId}/campaign/${this.campaignId}/price`,
      {
        type: this.$budgetType.val(),
        duration: this.$duration.val()
      }, function (response) {
        self.account = response.data.account
        self.priceMap = response.data.budgets
        self.bind()
        self.setTypes()
        self.setAmounts()
        self.checkDepositValue()
      })
  }
  
  checkDepositValue () {
    
    try {
      let selectedType = this.$budgetType.filter(
        (i, item) => $(item).is(':checked')).val()
  
      let duration = this.$duration.filter(
        (i, item) => $(item).is(':checked')).val()
  
      const amount = this.priceMap[selectedType][duration].amount
  
      if (this.account.balance < amount) {
        this.$alert.removeClass('d-none')
        this.$alert.html(i18n.gettext('yandex_subscription.need_replenish', $('.replenish-button').prop('href')))
        this.$startCampaignButton.prop('disabled', true);
      } else {
        this.$alert.html('')
        this.$alert.addClass('d-none')
        this.$startCampaignButton.prop('disabled', false);
      }
      
    } catch (e) {
    
    }
    
  }
  
  setAmounts () {
    
    let selectedType = this.$budgetType.filter(
      (i, item) => $(item).is(':checked')).val()
    
    const durationsList = this.priceMap[selectedType].durations
    
    for (let durationItem in durationsList) {
      const amount = durationsList[durationItem].amount
      const amountWithoutPromoDiscount = durationsList[durationItem].amountWithoutPromoDiscount
      const durationPercentDiscount = durationsList[durationItem].durationPercentDiscount
      
      let amountText = ''
      
      if (amount < amountWithoutPromoDiscount) {
        amountText = $('<span>').
          css({ textDecoration: 'line-through', opacity: 0.4 }).
          html(format(amountWithoutPromoDiscount, 'RUB')).
          prop('outerHTML') + ' '
      }
      
      amountText += format(amount, 'RUB')
      
      let labelText = $('<span>').
        html(i18n.gettext('yandex_subscription.campaign.duration', durationItem,
          amountText)).
        prop('outerHTML')
      
      if (parseInt(durationPercentDiscount) > 0) {
        labelText += ' ' + $('<span>').
          addClass('b-campaign__discount-label').
          text(i18n.gettext('yandex_subscription.campaign.benefit') + ' ' +
            durationPercentDiscount + '%').
          prop('outerHTML')
      }
      
      this.$duration.filter((i, item) => $(item).val() === durationItem).
        next('label').
        html(labelText)
    }
    
    this.$form.trigger('blur')
  }
  
  setTypes () {
    
    for (let type in this.priceMap) {
      const price = format(this.priceMap[type].durations[this.$duration.val()].amount, 'RUB')
      const predictionPhrase = $('<span>').text(i18n.gettext('yandex_subscription.campaign.prediction', parseInt(this.priceMap[type].monthPrediction).toLocaleString(settings.LOCALE)))
      predictionPhrase.addClass('b-campaign__budget-label-predict')
      
      const labelText = $('<span>').addClass('b-campaign__budget-label').html(i18n.gettext('yandex_subscription.campaign.budget', price, predictionPhrase.prop('outerHTML') ))
  
      this.$budgetType.filter('input[value="' + type + '"]').next('label').html(labelText)
    }
  }
  
  init () {
    this.getPrice()
    
  }
  
  bind() {
    let self = this
    
    this.$budgetType.on('change', (e) => {
      self.$budgetType.each((i, type) => type.removeAttribute('checked'))
      e.currentTarget.setAttribute('checked', 'checked')
      self.setAmounts()
    })
  
    this.$budgetType.on('input blur change',(e)=> {
      self.checkDepositValue()
    })
  
    this.$duration.on('input blur change',(e)=> {
      self.checkDepositValue()
    })
  
    this.$promocodeBtnApply.on('click', (e) => {
      const promocodeValue = this.$promocodeField.val().trim()
    
      if (promocodeValue.length > 0) {
        $.ajax(
          `/api/app/v1/networks/yandex-subscription/${this.accountId}/campaign/${this.campaignId}/promocode/apply`,
          {
            method: 'POST',
            data: {
              value: promocodeValue
            }
          }).done((response) => {
          self.priceMap = response.data
          self.setTypes()
          self.setAmounts()
          self.$promocodeField.prop('disabled', true)
          self.$module.find('.b-campaign__promocode-btn-container').
            addClass('applied')
          toastr.success(
            i18n.gettext('yandex_subscription.promocode.apply.success'))
        }).fail((resp) => {
          if (resp.responseJSON?.errors.length > 0) {
            toastr.error(i18n.gettext(resp.responseJSON.errors[0]))
          }
        })
      }
    
    })
  
    this.$promocodeBtnDiscard.on('click', (e) => {
      $.ajax(
        `/api/app/v1/networks/yandex-subscription/${this.accountId}/campaign/${this.campaignId}/promocode/discard`,
        {
          method: 'POST'
        }).done(() => {
        this.$promocodeField.removeAttr('disabled')
        self.$module.find('.b-campaign__promocode-btn-container').
          removeClass('applied')
        toastr.success('Отмена прошла успешно')
      }).fail(() => {
        toastr.error('Ошибка отмены промокода')
      })
    })
  
    this.$form.on('submit', (e) => {
      this.$promocodeField.removeAttr('disabled')
    })
  }
}

$(function () {
  $('.js-yandex-subscription-start-campaign').each(function () {
    new Module($(this))
  })
})
